import React from 'react';
import PropTypes from 'prop-types';
import { designSystem, Modal } from '@yola/ws-ui';
import bowser from 'yola-bowser';
import CheckMarkIcon from './check-mark-icon';

const MODAL_WIDTH = 418;
const { Stack, Heading, Paragraph, ActionButton, Box } = designSystem;

const DifmBannerFinish = ({ onSubmit }) => (
  <Modal
    className="ws-difm-banner-finish-modal"
    width={MODAL_WIDTH}
    height="auto"
    overlay="visible"
    resizable={false}
    draggable={false}
    fullscreen={bowser.mobile}
    centered
  >
    <Box padding="spacing-l" paddingTop="spacing-xl">
      <Stack gap="spacing-m">
        <div className="ws-difm-banner-finish-icon">
          <CheckMarkIcon />
        </div>
        <Stack gap="spacing-3-xs">
          <Heading type="heading-4" align="center">
            Thanks for choosing our service!
          </Heading>
          <Paragraph align="center">Our Do-It-For-Me team will contact you shortly</Paragraph>
        </Stack>
        <Paragraph align="center">
          <ActionButton label="Okay" onClick={onSubmit} />
        </Paragraph>
      </Stack>
    </Box>
  </Modal>
);

DifmBannerFinish.propTypes = {
  onSubmit: PropTypes.func.isRequired,
};

export default DifmBannerFinish;
